import * as React from 'react';
import { RouteChildrenProps, RouteComponentProps, withRouter } from 'react-router';

export interface AppState {
    location: RouteChildrenProps['location'];
}

export const initialAppState = {
    location: {
        pathname: '/',
        hash: '',
        search: '',
        state: undefined,
    },
};

const AppContext = React.createContext<AppState>(initialAppState);

type AppProviderProps = React.PropsWithChildren<RouteComponentProps>;

const AppProvider = withRouter(({ location, children }: AppProviderProps) => {
    const memoizedValue = React.useMemo(() => ({ location }), [location]);

    return <AppContext.Provider value={memoizedValue}>{children}</AppContext.Provider>;
});

AppContext.displayName = 'AppContext';

const useAppContext = (): AppState => {
    const context = React.useContext(AppContext);

    if (!context) {
        throw new Error('useAppContext must be used within a AppContextProvider');
    }
    return context;
};

export { AppProvider, useAppContext };
